declare namespace $ {

	type $mol_button_minor__title_shm_ba_profile_switch_1 = $mol_type_enforce<
		ReturnType< $shm_ba_profile_switch['login'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_shm_ba_profile_switch_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_profile_switch_3 = $mol_type_enforce<
		ReturnType< $shm_ba_profile_switch['exit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_pop_over__Anchor_shm_ba_profile_switch_4 = $mol_type_enforce<
		ReturnType< $shm_ba_profile_switch['Login'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_ba_profile_switch_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	export class $shm_ba_profile_switch extends $mol_view {
		login( ): string
		Login( ): $mol_button_minor
		exit( next?: any ): any
		Exit( ): $mol_button_minor
		Current( ): $mol_pop_over
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=switch.view.tree.d.ts.map